module.exports = __webpack_public_path__ + "static/media/dead-body.ed669e47.svg";